import apiHeader from "../apiHeader";
import api from "../axiosService";

export const getScholarShipList = async (payload) => {
    const res = await api.get("scholarship/getScholarships", {
      Headers: apiHeader(),
      params: payload,
    });
    return res;
  };